module.exports = __webpack_public_path__ + "static/media/bulb-black.d5cf538c.svg";